import { DateTime } from 'luxon';
import { DateRangeParams } from '@/api/schema';

export function getCurrentMonthPeriodDates(
  includeFullLastMonth: boolean = false
): DateRangeParams {
  const today: DateTime = DateTime.now();

  if (includeFullLastMonth && today.day === 1) {
    return {
      from: today.minus({ month: 1 }).startOf('month').toFormat('yyyy-LL-dd'),
      to: today.minus({ day: 1 }).toFormat('yyyy-LL-dd')
    };
  } else {
    return {
      from: today.startOf('month').toFormat('yyyy-LL-dd'),
      to: today.minus({ day: 1 }).toFormat('yyyy-LL-dd')
    };
  }
}

export function getMonthPeriodDates(
  isIncludeToday: boolean = false
): DateRangeParams {
  return {
    from: DateTime.utc()
      .minus({ day: isIncludeToday ? 0 : 1 })
      .minus({ months: 1 })
      .toFormat('yyyy-LL-dd'),
    to: DateTime.utc()
      .minus({ day: isIncludeToday ? 0 : 1 })
      .toFormat('yyyy-LL-dd')
  };
}

export function getHalfYearPeriodDates(
  isIncludeToday: boolean = false
): DateRangeParams {
  return {
    from: DateTime.utc()
      .minus({ day: isIncludeToday ? 0 : 1 })
      .minus({ months: 6 })
      .toFormat('yyyy-LL-dd'),
    to: DateTime.utc()
      .minus({ day: isIncludeToday ? 0 : 1 })
      .toFormat('yyyy-LL-dd')
  };
}
